var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-view fr"},_vm._l((_vm.imgs),function(i,k){return _c('el-image',{key:i,class:{mr20:k!= _vm.imgs.length-1},style:({width: _vm.width,height: _vm.height}),attrs:{"src":i,"preview-src-list":_vm.imgs}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-035d1cc4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/imgView.vue
// module id = STzb
// module chunks = 2